/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-extra-boolean-cast */
/* eslint-disable @typescript-eslint/ban-types */
import { CircularProgress, makeStyles } from "@material-ui/core";
import { Group } from "@material-ui/icons";
import { cardTitle } from "assets/jss/material-dashboard-pro-react";
import Card from "components/UI/Card/Card";
import CardBody from "components/UI/Card/CardBody";
import CardHeader from "components/UI/Card/CardHeader";
import CardIcon from "components/UI/Card/CardIcon";
import FieldglassButton from "components/UI/FieldglassButton";
import GridItemTS from "components/UI/Grid/GridItemTS";
import ReactTable from "components/Tables/ReactTable/ReactTable";
import { useTranslation } from "react-i18next";

const styles: any = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px",
  },
};

interface WorkerTableProps {
  data: Array<Object>;
  omit?: Array<string>;
  initialRowsPerPage?: number;
  isLoading: boolean;
}

const useStyles = makeStyles(styles);

export const WorkerRelatedTable = ({
  data,
  omit,
  initialRowsPerPage = 20,
  isLoading = false,
}: WorkerTableProps) => {
  const { t } = useTranslation("worker-profile");
  const classes = useStyles();

  const columns: any = [
    {
      Header: t("worker-table-id"),
      accessor: "code",
    },
    {
      Header: t("worker-table-name"),
      accessor: "name",
    },
    {
      Header: t("worker-table-email"),
      accessor: "email",
    },
    {
      Header: "DNI",
      accessor: "numberDNI",
    },
    {
      Header: t("provider-id"),
      accessor: "vendorCode",
    },
    {
      Header: t("provider"),
      accessor: "vendorName",
    },
    {
      Header: t("worker-table-action"),
      accessor: "actions",
    },
  ];

  const columnsFiltered = columns.filter(
    (c: any) => !omit?.includes(c.accessor),
  );

  const gridItemProps: any = {
    xs: 12,
  };

  return (
    <GridItemTS key="work-related-table-grid" {...gridItemProps}>
      <Card>
        <CardHeader color="rose" icon>
          <CardIcon color="rose">
            <Group />
          </CardIcon>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-end",
            }}
          >
            <h4 className={classes.cardIconTitle}>
              {t("worker-table-worker")}
            </h4>
            <FieldglassButton type="worker" />
          </div>
        </CardHeader>
        <CardBody>
          {isLoading ? (
            <CircularProgress />
          ) : (
            <ReactTable
              columns={!!omit ? columnsFiltered : columns}
              data={data}
              initialPageSize={initialRowsPerPage}
              columnsNotTrimFilters={["name", "vendorName"]}
            />
          )}
        </CardBody>
      </Card>
    </GridItemTS>
  );
};
